import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { generate_sequence, sleep } from "@/util";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  shownLength: { type: Number, default: 34 },
  emptyLength: { type: Number, default: 10 },
  sequenceLength: { type: Number, default: 20 },
  digitDistance: { type: Number, default: 4 },
},
  emits: ["start", "stop"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "start", digits: [number, number]): void;
  (e: "stop"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const characterDisplay = ref(null as null | HTMLDivElement);





let blinkTestAbort: null | AbortController = null;

async function runBlinkTest() {
  if (blinkTestAbort !== null) {
    blinkTestAbort.abort();
  }
  blinkTestAbort = new AbortController();
  const abortSignal = blinkTestAbort.signal;

  const sequenceLength = props.sequenceLength;
  const digitDistance = Math.min(props.sequenceLength - 1, props.digitDistance);
  const digitStart = Math.floor(
    Math.random() * (sequenceLength - digitDistance)
  );

  const { sequence, usedDigits } = generate_sequence(
    sequenceLength,
    digitDistance,
    digitStart
  );
  console.log(sequence);

  const shownLength = props.shownLength;
  const emptyLength = props.emptyLength;
  const countdownTime = 250;

  emits("start", usedDigits as [number, number]);

  const putChar = async (char: string, timeout: number) => {
    if (abortSignal.aborted) return;
    if (characterDisplay.value === null) return;

    characterDisplay.value.innerText = char;
    await sleep(timeout);
  };

  const characters = ["\u25D4", "\u25D1", "\u25D5", ""];
  for (const char of characters) {
    await putChar(char, countdownTime);
  }

  for (const c of sequence) {
    await putChar("", emptyLength);
    await putChar(c, shownLength);
  }

  await putChar("", 0);

  if (!abortSignal.aborted) {
    blinkTestAbort = null;
    emits("stop");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ character: true, noTest: _unref(blinkTestAbort) === null }),
    ref_key: "characterDisplay",
    ref: characterDisplay,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (runBlinkTest()))
  }, null, 2))
}
}

})